import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_branch_designation_RowClass} from '../../dbschema';

export class BranchDesignationContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_designation: bl_fi_mst_branch_designation_RowClass = new bl_fi_mst_branch_designation_RowClass();
}
